import type { HttpClient } from '~/api/client';
import { httpClient } from '~/api/client';
import type { OrderDetail, OrderHistoryPage } from '~/api/model';

// Response 타입 (Zod Model 재사용 — OAISchema 금지, api-typegen §0)
export type OrderHistoryPageResponse = OrderHistoryPage;

type OrderDetailResponse = OrderDetail;

export interface OrderDataSource {
  getOrderHistories(params?: {
    lastOrderId?: number;
    size?: number;
  }): Promise<OrderHistoryPageResponse>;
  getOrderDetail(orderId: number): Promise<OrderDetailResponse>;
}

export class OrderDataSourceImpl implements OrderDataSource {
  // eslint-disable-next-line no-useless-constructor
  constructor(private readonly client: HttpClient = httpClient) {}

  async getOrderHistories(params?: { lastOrderId?: number; size?: number }) {
    return this.client.request<OrderHistoryPageResponse>({
      url: '/api/market-place/v1/orders',
      method: 'get',
      params,
    });
  }

  async getOrderDetail(orderId: number) {
    return this.client.request<OrderDetailResponse>({
      url: `/api/market-place/v2/orders/${orderId}/details`,
      method: 'get',
    });
  }
}

export const orderDataSource = new OrderDataSourceImpl();
